import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PrevilegeAuthorizationService } from '../services/privilege-authorization.service';

@Directive({
  selector: '[appPrevilegeAuth]'
})

  export class PrevilegeAuthorizationDirective implements OnChanges {
    @Input('appPrevilegeAuth') PrevilegeKey: string;
    constructor(
        private element: ElementRef,
        private Renderer: Renderer2,
        public activatedRoute: ActivatedRoute,
        public previlegeAuthorizationService: PrevilegeAuthorizationService
        ) {
    }
    ngOnChanges() {
        const IsAuthenticated = this.previlegeAuthorizationService.previlegAuthorization([this.PrevilegeKey]);
        if ( IsAuthenticated ) {
          this.Renderer.removeClass(this.element.nativeElement, 'd-none');
        } else {
          this.Renderer.addClass(this.element.nativeElement, 'd-none');
        }
      }

  }
